import { Component } from '@angular/core';
import { ChiSiamoComponent } from "../chi-siamo/chi-siamo.component";
import { ServiziComponent } from "../servizi/servizi.component";
import { FeedbackComponent } from "../feedback/feedback.component";
import { GalleriaComponent } from "../galleria/galleria.component";
import { TeamComponent } from "../team/team.component";
import { CorsiComponent } from "../servizi/corsi/corsi.component";
import { ContattaciComponent } from "../contattaci/contattaci.component";
import { NewsComponent } from "../news/news.component";
import { SliderAreaComponent } from "../slider-area/slider-area.component";

@Component({
    selector: 'app-home',
    imports: [ServiziComponent, FeedbackComponent, TeamComponent, SliderAreaComponent, CorsiComponent],
    templateUrl: './home.component.html',
    styleUrl: './home.component.css'
})
export class HomeComponent {

}
